<template>
	<td class="text-no-wrap text-center subtitle-2 font-weight-bold">
		<v-row>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="percent"
						class="subtitle-2 font-weight-bold"
						v-model="percent"
						suffix="%"
						digits="1"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="percentChange"
					>
						<template v-slot:prepend-inner>
							<v-icon x-small class="py-2">add</v-icon>
						</template>
					</a-number-field-inline>
				</template>
				<template v-else>
					+ {{ percent }}%
				</template>
			</v-col>
			<v-col cols="6" class="py-1">
				<template v-if="editMode">
					<a-number-field-inline
						ref="sum"
						class="subtitle-2 font-weight-bold"
						v-model="sum"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@change="sumChange"
					></a-number-field-inline>
				</template>
				<template v-else>
					<!-- {{ toStr(sum) }} -->
					<v-chip
						outlined
						:class="editMode ? '' : 'px-0 d-block'"
						color="secondary"
						text-color="primary"
					>
						{{ toStr(sum) }}
					</v-chip>
				</template>
			</v-col>
		</v-row>
	</td>
</template>

<script>
	import { toStr, toNum } from '../../../js/common'
	import { c } from '../../../lib/const'
	import aNumberFieldInline from '../../base/ANumberFieldInline.vue'

	export default {
		components: {
			aNumberFieldInline,
		},
		props: {
			sumNet: [ String, Number ],
			sumGross: [String, Number],
			editMode: Boolean
		},
		data: function() {
			return {
				percent: '',
				sum: '',
				tax: c.PAYROLL_TAX,
			}
		},
		watch: {
			sumNet(val, old) {
				// console.log('component - sumNet watcher', val)

				if (old != 0) {
					this.sum = toStr((1 + toNum(this.percent) / 100) * val)
				}
				else {
					this.sum = toStr((1 + this.tax / 100) * val)
					this.percent = this.tax
				}

				this.$emit('update:sumGross', this.sum)
			}
		},
		created() {
			this.sumChange(this.sumGross, false)
		},
		methods: {
			percentChange(val, emit) {
				if (emit === undefined) emit = true

				val = toNum(val)
				val = val < 0 ? 0 : val
				val = val > this.tax ? this.tax : val
				// console.log('val', val)
				this.percent = val.toFixed(1)
				this.sum = toStr((100 + val) / 100 * this.sumNet)

				if (emit) {
					this.$emit('update:sumGross', this.sum)
				}
			},
			sumChange(val, emit) {
				if (emit === undefined) emit = true
				// console.log('sumChange', val)
				// console.log('sumNet', this.sumNet)

				val = toNum(val)
				// console.log('val', val)
				val = val < this.sumNet ? this.sumNet : val
				// console.log('val', val)
				let max = this.sumNet * (1 + this.tax / 100)
				// console.log('max', max)
				// console.log('val', val)
				val = val > max ? max : val
				// console.log('val', val)
				this.sum = toStr(val)
				// console.log('sum', this.sum)

				if (this.sumNet != 0) {
					this.percent = (toNum(this.sum) / this.sumNet * 100 - 100).toFixed(1)
				}
				else {
					this.percent = 0
				}

				if (emit) {
					this.$emit('update:sumGross', this.sum)
				}
			},
			toStr(val) {
				return toStr(val)
			},
		}
	}
</script>

<style scoped>

</style>
